import { IGroupFixture } from "core-integration/src/store/fixtures/types";
import { getTeamsById } from "core-integration/src/store/teams/reducers";
import { Disclosure, DisclosurePanel } from "react-aria-components";
import { useSelector } from "react-redux";
import { usePlosTranslations } from "../../../contexts/PlosTranslationsContext";
import ChevronDown from "../../../img/icons/chevron-down.svg?react";
import { UnstyledRACButton } from "../../buttons/UnstyledRACButton";
import { FixtureStats } from "../FixtureStats";
import Fixture from "./Fixture";
import { chevronDownIcon, fixtureDisclosureButton } from "./fixture.css";

interface FixtureWithStatsProps {
  fixture: IGroupFixture;
}

const FixtureWithStats = ({ fixture }: FixtureWithStatsProps) => {
  const { fixtures } = usePlosTranslations();
  const teamsById = useSelector(getTeamsById);
  const fixtureStarted = fixture.started && fixture.team_h_score !== null;

  return (
    <Disclosure>
      <div style={{ position: "relative" }}>
        <Fixture fixture={fixture} inDisclosure />
        {fixtureStarted && (
          <UnstyledRACButton
            className={fixtureDisclosureButton}
            slot="trigger"
            aria-label={fixtures.fixtureStats(
              teamsById[fixture.team_h].name,
              teamsById[fixture.team_a].name,
            )}
          >
            <ChevronDown width={24} height={24} className={chevronDownIcon} />
          </UnstyledRACButton>
        )}
      </div>
      <DisclosurePanel>
        <FixtureStats fixture={fixture} />
      </DisclosurePanel>
    </Disclosure>
  );
};

export default FixtureWithStats;
